







































































































  

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { BookingWizardModule } from '@/store/modules/bookingWizard';
import PositionDto from '@/models/Positions/PositionDto';
import ShiftViewModel from '@/models/Shifts/ShiftViewModel';
import BookingRoleViewModel from '@/models/BookingRoles/BookingRoleViewModel';
import BreakDto from '@/models/Shared/BreakDto';
import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'BookingWizardBookingRoleEdit'
})
export default class extends GiganautVueDialog {
 
    @Prop({required: true})
    public index: number;

    public dialog = false;
    public entity = new BookingRoleViewModel();

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.entity = JSON.parse(JSON.stringify(BookingWizardModule.newBooking.roles[this.index]));
            //also set the ID to the index so it can be identified for updates
            this.entity.id = this.index.toString();
        }
    }

    get skills() {
        return this.entity.rateCardPosition.position.skills;
    }

     get qualifications() {
        return this.entity.rateCardPosition.position.qualifications;
    }

    get desks() {
        return BookingWizardModule.newBookingOptions.desks;
    }

    get uniforms() {
        return this.entity.rateCardPosition.position.uniforms;
    }

    get currentPosition() {
        return this.entity.rateCardPosition.position;
    }

    get loading() {
        return BookingWizardModule.loadingDialog;
    }

    save() {
        BookingWizardModule.updateNewBookingRole(this.entity);
        this.dialog = false;
    }
}
